import { useUiText } from "../../locale/UiLocale";
import { Icon } from "../../icons";
import type { FilterOption } from "./DataTableTypes";
import { NO_FILTER } from "./filterOptions";

interface FilterMenuProps {
  label: string;
  value: string;
  options: FilterOption[];
  /** Called with the picked value, or with no filter when the chosen option is picked again. */
  onPick: (value: string) => void;
}

/** The options of a filter pill; picking the selected option again clears the filter. */
export function FilterMenu({ label, value, options, onPick }: FilterMenuProps): React.JSX.Element {
  const t = useUiText();
  return (
    <>
      <div className="nb-menu-label">{`${t("Filter by")} ${label.toLowerCase()}`}</div>
      {options.length === 0 ? (
        <div className="nb-menu-item" aria-disabled="true">
          {t("No options")}
        </div>
      ) : null}
      {options.map((o) => {
        const selected = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="option"
            aria-selected={selected}
            className={`nb-menu-item${selected ? " is-selected" : ""}`}
            onClick={() => onPick(selected ? NO_FILTER : o.value)}
          >
            <span className="nb-truncate">{o.label}</span>
            <Icon name="check" className="nb-menu-check" />
          </button>
        );
      })}
    </>
  );
}
